import { useMemo, useState, type ReactElement } from 'react';
import { useConfig, useServices, useT } from '../../../app/di';
import { Button } from '../../../ui-kit/Button/Button';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Card } from '../../../ui-kit/Card/Card';
import { useBlog } from './blog-context';
import { BlogForm } from './BlogForm/BlogForm';
import { blogValuesOf } from './model/blog-form';

// WS-UC-3, WS-RULE-1, WS-UC-3.CC-1
export function BlogSettingsSection(): ReactElement {
  const { api, session } = useServices();
  const { ui } = useConfig();
  const { t } = useT();
  const { blog, reloadBlog } = useBlog();
  const [saved, setSaved] = useState(false);
  const initial = useMemo(() => blogValuesOf(blog), [blog]);

  return (
    <Card title={t('workspaces.settings.blog')}>
      <div className="u-stack">
        {saved ? <Alert tone="success">{t('common.saved')}</Alert> : null}
        <BlogForm
          id="blog-settings"
          initial={initial}
          timeZonePageSize={ui.timeZones.pageSize}
          onSubmit={async (values) => {
            setSaved(false);
            const result = await api.workspaces.update(blog.id, values);
            if (result.success) {
              setSaved(true);
              await Promise.all([reloadBlog(), session.refresh()]);
            }
            return result;
          }}
          footer={({ submitting }) => (
            <div>
              <Button type="submit" variant="primary" loading={submitting}>
                {t('common.save')}
              </Button>
            </div>
          )}
        />
      </div>
    </Card>
  );
}
